import React from "react";
import PropTypes from "prop-types";
import styles from "./ProgressBar.module.css";

/**
 * Cor da barra varia por proximidade do prêmio.
 * - < 50% → azul (Nexus primary)
 * - 50%-79% → âmbar (chama atenção)
 * - 80%-99% → verde (quase lá!)
 * - >= 100% → verde com glow leve (prêmio disponível)
 *
 * Mantemos hex inline porque essas cores são parte do design SPEC do briefing
 * (não fazem parte do design system geral do app — são semânticas dessa tela).
 */
function getBarColor(pct) {
  if (pct >= 100) return "#27AE60";
  if (pct >= 80) return "#27AE60";
  if (pct >= 50) return "#F39C12";
  return "#3498DB";
}

export default function ProgressBar({ value, max, ariaLabel = undefined }) {
  // Defesa contra `max === 0` (programa sem `requiredVisits` por algum motivo)
  // ou `value` negativo — UI nunca deve quebrar por dado ruim do backend.
  const safeMax = Number.isFinite(max) && max > 0 ? max : 1;
  const safeValue = Math.max(0, Number.isFinite(value) ? value : 0);
  const pct = Math.min((safeValue / safeMax) * 100, 100);
  const color = getBarColor(pct);

  return (
    <div
      role="progressbar"
      aria-valuenow={safeValue}
      aria-valuemin={0}
      aria-valuemax={safeMax}
      aria-label={ariaLabel || `${safeValue} de ${safeMax}`}
      className={`${styles.track} ${pct >= 100 ? styles.trackComplete : ""}`.trim()}
    >
      <div
        className={styles.fill}
        style={{
          width: `${pct}%`,
          "--nx-loyalty-bar-color": color,
        }}
      />
    </div>
  );
}

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  ariaLabel: PropTypes.string,
};
